import React from "react";
import { discountsIntro, discounts } from "../data/discounts";
import "../styles/discounts.css";

export default function DiscountsPage() {
  return (
    <main className="discounts">
      {/* Intro */}
      <section className="container text-center py-5">
        <h1 className="disc-title">{discountsIntro.title}</h1>
        <p className="disc-subtitle">{discountsIntro.subtitle}</p>
      </section>

      {/* Blocks */}
      <section className="container pb-5">
        {discounts.map((d) => {
          const imgRight = d.imageSide === "right";
          return (
            <div
              className="row align-items-center g-5 mb-5 py-5 px-1"
              key={d.id}
            >
              {/* IMAGE */}
              <div className={`col-lg-6 ${imgRight ? "order-lg-2" : ""}`}>
                <div className="hero-wrap">
                  <img
                    src={d.hero}
                    alt={d.heading}
                    className="img-fluid hero"
                    loading="lazy"
                  />
                </div>
              </div>

              {/* TEXT */}
              <div className={`col-lg-6 ${imgRight ? "order-lg-1" : ""}`}>
                <h2 className="disc-heading">{d.heading}</h2>
                <ul className="disc-bullets">
                  {d.bullets.map((b, j) => (
                    <li key={j}>{b}</li>
                  ))}
                </ul>

                {d.cta && (
                  <a
                    href={d.cta.href}
                    className="btn disc-btn mt-3"
                    rel="noopener"
                  >
                    {d.cta.label}
                  </a>
                )}
              </div>
            </div>
          );
        })}
      </section>
    </main>
  );
}
